<template>
  <b-tabs
    content-class="col-12 px-sm-1 px-0  mb-sm-0 mb-5"
    pills
    nav-wrapper-class=" col-12"
    nav-class="justify-content-center"
    v-model="tabs"
  >
    <b-tab
      v-if="session.access && session.is_seen && exercises && exercises.length"
    >
      <template #title>
        <feather-icon icon="RefreshCcwIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">تمرین ها</span>
      </template>
      <exercises-tab
        :exercises="exercises"
        @getSession="$emit('getSession')"
        @getCourse="$emit('getCourse')"
      />
    </b-tab>
    <b-tab v-if="session.description">
      <template #title>
        <feather-icon icon="BookOpenIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">توضیحات</span>
      </template>
      <b-card>
        <div class="text-justify p-sm-1" v-html="session.description"></div>
      </b-card>
    </b-tab>

    <b-tab v-if="session.pamphlet">
      <template #title>
        <feather-icon icon="RefreshCcwIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">جزوه ها</span>
      </template>
      <docs-tab
        :pamphlet="session.pamphlet"
        :pamphlet_file="session.pamphlet_file"
      />
    </b-tab>

    <b-tab v-if="session.faqs && session.faqs.faqs && session.faqs.faqs.length">
      <template #title>
        <feather-icon icon="FileTextIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">پرسش و پاسخ</span>
      </template>
      <faqs-tab :faqs="session.faqs.faqs" />
    </b-tab>
    <b-tab v-if="session.access">
      <template #title>
        <feather-icon icon="TwitchIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">سوالات کاربران</span>
      </template>
      <comments regardingType="session" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BCard } from "bootstrap-vue";
import ExercisesTab from "./ExercisesTab.vue";
import DocsTab from "./DocsTab.vue";
import FaqsTab from "../../course-content/course-tabs/FaqsTab.vue";
import Comments from "@core/components/comments/Comments.vue";

export default {
  components: {
    BTabs,
    BTab,
    ExercisesTab,
    DocsTab,
    FaqsTab,
    Comments,
    BCard,
  },
  props: {
    session: {
      type: Object,
      default: () => {},
    },
    exercises: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tabs: 0,
    };
  },
};
</script>
